import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import IndustryDimensionValue from "./industryDimensionValue";

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {},
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(IndustryDimensionValue);
